<template>
  <div class="bookType">
    <ComponentsList
      ref="componentsList"
      :props-columns="columns"
      :props-data="propsData"
      :search-form="searchForm"
      @editLinkType="editLinkTypeHandle"
    >
      <el-form
        ref="searchForm"
        :model="searchForm"
        :inline="true"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="图书编码" prop="bookCode">
          <el-input
            v-model="searchForm.bookCode"
            name="bookCode"
            placeholder="请输入图书编码"
            class="handle-form-input"
            maxlength="50"
            clearable
          />
        </el-form-item>
        <el-form-item label="名称" prop="bookName">
          <el-input
            v-model="searchForm.bookName"
            name="bookName"
            placeholder="请输入图书名称"
            class="edit-form-input"
            maxlength="50"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-search"
            @click="handleSearchFilter"
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>
    </ComponentsList>
    <el-dialog
      v-if="handleFormAdd.dialogAddVisible"
      :close-on-click-modal="false"
      :visible.sync="handleFormAdd.dialogAddVisible"
      title="关联分类"
      width="600px"
    >
      <el-tree
        ref="bookTypesTyee"
        :check-strictly="checkStrictly"
        :data="apptypesTree"
        :props="defaultProps"
        :default-checked-keys="defaultKeys"
        default-expand-all
        show-checkbox
        node-key="id"
      />
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleFormAdd.dialogAddVisible = false">
          取消
        </el-button>
        <el-button
          :loading="ajaxLoading"
          type="primary"
          size="medium"
          @click="handleBookLinkType"
        >
          {{ ajaxLoading?'Loading':'确定' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import EllaRentBooks from '@/api/userManagement/ellaRentBooks';
import ComponentsList from '@/views/financialCenter/ellaRentBooks/common/componentsList';
import { columnsFreeBooks } from '@/views/financialCenter/ellaRentBooks/common/columns';

export default {
  name: 'FreeBooks', // 限免专区
  components: { ComponentsList },
  props: {
    code: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      ajaxLoading: false,
      checkStrictly: false,
      defaultKeys: [],
      searchForm: {
        bookCode: '',
        isLimitFree: 1,
        pageNum: 1,
        total: 0,
        pageSize: 10,
        limitFreeArea: ''
      },
      propsData: {
        api: 'get_books_pageList',
        del: 'get_books_limit_free_del'
      },
      handleFormAdd: {
        dialogAddVisible: false,
        id: ''
      }
    };
  },
  computed: {
    columns() {
      return columnsFreeBooks;
    },
    defaultProps() {
      return this.$refs.componentsList.defaultProps;
    },
    apptypesTree() {
      return this.$store.state.ella.apptypesTree;
    }
  },
  watch: {
    code: {
      handler(val) {
        if (val) {
          this.searchForm.limitFreeArea = val;
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.searchForm.limitFreeArea = this.code;
  },
  methods: {
    // 关联分类
    editLinkTypeHandle(val) {
      this.handleFormAdd.id = val.id;
      const types = [];
      val.types.forEach(element => {
        types.push(element.secondTypeId);
      });
      this.defaultKeys = [...new Set(types)];
      this.handleFormAdd.dialogAddVisible = true;
    },
    // 添加关联分类
    handleBookLinkType() {
      this.ajaxLoading = true;
      const treeObj = this.$refs.bookTypesTyee;
      const checkedList = treeObj.getCheckedNodes();
      const bookTypeIds = checkedList.filter(x => !x.children).map(v => v.id);
      const bookIds = [this.handleFormAdd.id];
      const op = {
        bookIds,
        bookTypeIds
      };
      EllaRentBooks['get_booksLinkType_pageList'](op).then((res) => {
        if (res.code === '0') {
          this.handleFormAdd.dialogAddVisible = false;
          this.$message.success('操作成功');
          this.$refs.componentsList.fetchdataList();
        }
        this.ajaxLoading = false;
      }).catch(err => {
        console.log(err);
        this.ajaxLoading = false;
      });
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.$refs.componentsList.fetchdataList();
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
